import {
  KeyboardArrowDown,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
} from '@mui/icons-material';
import React, { useState } from 'react';

const PatientActionBoxTrigger = ({
  Patient,
  setFiles,
  files,
}) => {
  const HandleCacheSelection = () => {
    const cachedFiles =
      sessionStorage.getItem('files') &&
      JSON.parse(sessionStorage.getItem('files'));

    const duplicateFile =
      cachedFiles?.filter((fl) => fl === Patient?.FldId)
        .length > 0;

    if (duplicateFile) {
      const fileterdArray = cachedFiles.filter(
        (fl) => fl !== Patient?.FldId
      );

      sessionStorage.setItem(
        'files',
        JSON.stringify(fileterdArray)
      );
      setFiles(fileterdArray);
    } else {
      if (cachedFiles) {
        sessionStorage.setItem(
          'files',
          JSON.stringify([...cachedFiles, Patient.FldId])
        );
        setFiles([...cachedFiles, Patient.FldId]);
        return;
      }

      sessionStorage.setItem(
        'files',
        JSON.stringify([Patient.FldId])
      );
      setFiles([Patient.FldId]);
    }
    console.log('Patient--->', Patient);
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          alignSelf: 'center',
          cursor: 'pointer',
        }}
        onClick={HandleCacheSelection}
      >
        {files?.includes(Patient?.FldId) ? (
          <KeyboardDoubleArrowUp />
        ) : (
          <KeyboardDoubleArrowDown />
        )}
      </div>
    </React.Fragment>
  );
};

export default PatientActionBoxTrigger;
